<template>
  <v-card>
    <v-container>
      <v-data-table
        flat
        tile
        :headers="headers"
        :items="items"
        class="mb-2"
        @click:row="$emit('row-click', $event)"
        :search="search"
        :items-per-page="itemsperpage != null ? itemsperpage : 10"
        :must-sort="true"
        :sort-by="sortby"
        :sort-desc="sortbydesc == true ? true : false"
        :loading-text="loadingtext"
        :loading="loading"
        :hide-default-footer="hidefooter == true"
        @current-items="filteredItems = $event"
      >
        <template v-slot:[`item.laborCost`]="{ item }">
          <span
            >${{
              item.laborCost != null ? item.laborCost.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.laborRate`]="{ item }">
          <span
            >${{
              item.laborRate != null ? item.laborRate.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.hours`]="{ item }">
          <span>{{ item.hours != null ? item.hours.toFixed(2) : "0.00" }}</span>
        </template>
        <template v-slot:[`item.expenses`]="{ item }">
          <span
            >${{
              item.expenses != null ? item.expenses.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.labor`]="{ item }">
          <span
            >${{ item.labor != null ? item.labor.toFixed(2) : "0.00" }}</span
          >
        </template>
        <template v-slot:[`item.payments`]="{ item }">
          <span
            >${{
              item.payments != null ? item.payments.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.billedAmount`]="{ item }">
          <span
            >${{
              item.billedAmount != null ? item.billedAmount.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.rate`]="{ item }">
          <span>${{ item.rate != null ? item.rate.toFixed(2) : "0.00" }}</span>
        </template>
        <template v-slot:[`item.payRate`]="{ item }">
          <span
            >${{
              item.payRate != null ? item.payRate.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.balance`]="{ item }">
          <span
            >${{
              item.balance != null ? item.balance.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.duration`]="{ item }">
          <span>{{
            item.duration != null ? item.duration.toFixed(2) : "0.00"
          }}</span>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <span
            >${{ item.amount != null ? item.amount.toFixed(2) : "0.00" }}</span
          >
        </template>
        <template v-slot:[`item.billedExpenses`]="{ item }">
          <span
            >${{
              item.billedExpenses != null
                ? item.billedExpenses.toFixed(2)
                : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.billedLabor`]="{ item }">
          <span
            >${{
              item.billedLabor != null ? item.billedLabor.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.cost`]="{ item }">
          <span>${{ item.cost != null ? item.cost.toFixed(2) : "0.00" }}</span>
        </template>
        <template v-slot:[`item.revenue`]="{ item }">
          <span
            >${{
              item.revenue != null ? item.revenue.toFixed(2) : "0.00"
            }}</span
          >
        </template>
        <template v-slot:[`item.profit`]="{ item }">
          <span
            >${{ item.profit != null ? item.profit.toFixed(2) : "0.00" }}</span
          >
        </template>
        <template v-slot:footer v-if="footerdata != null">
          <v-divider></v-divider>
          <v-toolbar flat color="white">
            <v-flex>
              <v-card flat>
                <v-card-text><h3>Total Labor</h3></v-card-text>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card flat>
                <v-card-text></v-card-text>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card flat>
                <v-card-text>{{ footerdata.hours.toFixed(2) }} hrs</v-card-text>
              </v-card>
            </v-flex>
            <v-flex mr-3>
              <v-card flat>
                <v-card-text>${{ footerdata.amount.toFixed(2) }}</v-card-text>
              </v-card>
            </v-flex>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-layout>
            <v-flex>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="mb-2" v-on="on" icon>
                    <v-icon small @click.stop="$emit('edit-row', item)">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Edit {{ itemtype }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex v-if="actions != null && actions.includes('recalculate')">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="mb-2" v-on="on" icon>
                    <v-icon small @click.stop="$emit('recalculate', item)">
                      mdi-refresh
                    </v-icon>
                  </v-btn>
                </template>
                <span>Recalculate</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </template>
        <template v-slot:[`item.attachment`]="{ item }">
          <v-layout v-if="item.s3FilePath != null">
            <v-flex>
              <v-btn
                small
                color="primary"
                dark
                class="mb-2"
                icon
                @click.stop="getSubmissionImage(item)"
                ><v-icon small>
                  mdi-image
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template v-slot:top>
          <v-row justify="center">
            <v-col align="start" cols="2">
              <v-tooltip right v-if="showadd != false">
                <template v-slot:activator="{ on }">
                  <v-btn color="green lighten-1" class="mb-2" v-on="on" icon>
                    <v-icon @click="$emit('add-item')">
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </template>
                <span>Add {{ itemtype }}</span>
              </v-tooltip>
            </v-col>
            <v-col align="center">
              <h3>{{ title }}</h3>
            </v-col>
            <v-col align="end" cols="2">
              <v-tooltip left v-if="showexport != false">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="mb-2" v-on="on" icon>
                    <v-icon @click="downloadTable">
                      mdi-download
                    </v-icon>
                  </v-btn>
                </template>
                <span>Export {{ title }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row justify="center" row-wrap no-gutters>
            <v-col
              cols="12"
              :sm="5"
              align="center"
              v-if="showdaterange == true"
              class="mx-1"
            >
              <v-menu
                v-model="selectDateRange"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateRangeText"
                    v-on="on"
                    label="Date range"
                    prepend-icon="mdi-calendar"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dates"
                  range
                  @input="selectedDateRangeChange"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              :sm="5"
              align="center"
              class="mb-4 mx-1"
              v-if="showsearch != false"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-container>
  </v-card>
</template>

<script>
import moment from "moment";
import downloadCsv from "download-csv";

export default {
  name: "DataTable",
  props: [
    "title",
    "items",
    "headers",
    "itemtype",
    "showdaterange",
    "showsearch",
    "showadd",
    "showexport",
    "loading",
    "loadingtext",
    "footerdata",
    "hidefooter",
    "actions",
    "sortby",
    "sortbydesc",
    "itemsperpage"
  ],
  data: () => ({
    filteredItems: null,
    deleteRow: false,
    dialogLoading: false,
    dialogSuccessMessage: null,
    dialogErrorMessage: null,
    s3ImageName: null,
    s3ImageContentType: null,
    search: null,
    selectDateRange: false,
    sections: [],
    dates: []
  }),
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    }
  },
  methods: {
    selectedDateRangeChange() {
      if (this.dates.length == 2) {
        this.selectDateRange = false;
        this.$emit("date-range-selected", this.dates);
      }
    },
    getSubmissionImage(item) {
      let payload = {
        action: "getObject",
        path: item.s3FilePath
      };
      let fileArr = item.s3FilePath.split("/");
      this.s3ImageName = fileArr[fileArr.length - 1];
      this.s3ImageContentType = item.s3FileContentType;

      let self = this;
      self.$store.dispatch("getPresignedUrl", payload).then(result => {
        if (result.success == false) {
          self.$emit("error", result.data.error.message);
        } else {
          window.open(result.data, "_blank");
        }
      });
    },
    downloadTable() {
      let headers = {};

      for (var header of this.headers) {
        if (header.value != "attachment" && header.value != "action") {
          headers[header.value] = header.text;
        }
      }

      let data = [];

      for (var item of this.filteredItems) {
        var itemData = {};
        for (var xheader in headers) {
          itemData[xheader] =
            item[xheader] != null
              ? '"' +
                String(item[xheader])
                  .replace(/[\r\n]+/gm, " ")
                  .replace(/"/g, "") +
                '"'
              : null;
        }

        data.push(itemData);
      }

      downloadCsv(data, headers, this.title + ".csv");
    },
    resetErrors() {
      this.$emit("resetmessages");
      this.dialogSuccessMessage = null;
      this.dialogErrorMessage = null;
    }
  },
  beforeMount() {
    this.dates = [
      moment()
        .startOf("week")
        .format("YYYY-MM-DD"),
      moment()
        .endOf("week")
        .format("YYYY-MM-DD")
    ];
  }
};
</script>
